import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { APP_INSIGHTS_CONNECTION_STRING, ENV_NAME } from "./config";

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: APP_INSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    extensionConfig: {},
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
  },
});
appInsights.loadAppInsights();
// set cloud role name property
const telemetryInitializer = (envelope) => {   
  envelope.tags["ai.cloud.role"] = "FileOps Outlook Add-in";
 //ai.cloud.roleInstance property tag used in **Application Insights** to distinguish between different instances of an application running on different servers
 envelope.tags["ai.cloud.roleInstance"] = ENV_NAME;
}
appInsights.addTelemetryInitializer(telemetryInitializer);

export { reactPlugin, appInsights };
